module.exports = __webpack_public_path__ + "img/vn.8a0beafd.svg";